//logic for gallery component
const galleryComponent = {
    component: null,
    scEditorMode: null,
    galleries: [],
    selectedGallery: 0,
    mobileInitialised: false,
    desktopInitialised: false
};

galleryComponent.component = document.querySelector('.gallery-component');
if (galleryComponent.component) {
    galleryComponent.scEditorMode = document.querySelector('.sc-editor-mode');

    // Initialise Section Buttons in Gallery Header (common to desktop and mobile)
    const GALLERY_HEADER = document.querySelectorAll('.gallery-header');
    if (GALLERY_HEADER) {
        getGalleryStructure();
        if (!galleryComponent.scEditorMode) {
            //on page load make first btn of gallery header selected
            GALLERY_HEADER.forEach((galHeader) => {
                const GALLERY_TAB_HEADER_LINKS = galHeader.firstElementChild;
                const GALLER_TAB_HEADER_FIRST_LINK = GALLERY_TAB_HEADER_LINKS.firstElementChild;
                //on page load first btn of gallery header is selected
                window.addEventListener('load', () => {
                    setSelectedGallery(galHeader, GALLER_TAB_HEADER_FIRST_LINK);
                });
            });     
        }
        //handle tab functionality for gallery header buttons
        let handleGalleryLinkClick = (e) => {
            let galleryHeader = e.target.parentElement.parentElement;
            setSelectedGallery(galleryHeader, e.target);
        };
        Array.from(document.getElementsByClassName('gallery-tab-link'), (btn) =>
            btn.addEventListener('click', handleGalleryLinkClick, false)
        );
    }

    // Initialise Gallery for current mobile/desktop view
    if (mobileGalleryView()) {
        initializeMobileGallery();
    } else {
        initializeDesktopGallery();
    }

    // watch for orientation changes
    const orientationChangeHandler = function(event) {
        // use Timeout to delay to next JS cycle
        setTimeout(() => {
            // Check if current view is initialised and if not then initialise
            if (mobileGalleryView()) {
                if (!galleryComponent.mobileInitialised) {
                    initializeMobileGallery();
                }  else {
                    const galleryContent = document.querySelector(`.gallery-tab-header-content[data-tab="${galleryComponent.galleries[galleryComponent.selectedGallery].galleryTab}"]`);
                    const gallerySelect = galleryContent.querySelector('.gallery-select');
                    gallerySelect.selectedIndex = galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab;
                    const gallerySelectComponent = galleryContent.querySelector('.gallery-select-component');
                    setActivetMobileGalleryTab(gallerySelectComponent);            
                }
            } else {
                if (!galleryComponent.desktopInitialised) {
                    initializeDesktopGallery();
                } else {
                    const galleryComponentHeader = galleryComponent.component.querySelector('.gallery-header');
                    const tab = galleryComponentHeader.querySelector(`.tablinks[data-id*="${galleryComponent.galleries[galleryComponent.selectedGallery].tabs[galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab].id}"]`)
                    setActiveGalleryTab(tab);
                }
            }
        });
    };
 
    // add an orientation change listner
    windowUtils.addOrientationListener(orientationChangeHandler);

    function getGalleryStructure() {
        const galleryTablinks = galleryComponent.component.querySelectorAll('.gallery-header .gallery-tab-link');
        galleryTablinks.forEach((tablink) => {
            const gallery = {
                galleryTab: tablink.dataset.tab,
                selectedTab: 0,
                tabs: []
            };
            const galleryTab = document.querySelector(`.gallery-tab-header-content[data-tab="${tablink.dataset.tab}"]`);
            const galleryTabLinks = galleryTab.querySelectorAll('.gallery-links-wrapper .tablinks');
            galleryTabLinks.forEach((tablink) => {
                const tab = {
                    id: tablink.dataset.id
                };
                gallery.tabs.push(tab);
            });
            galleryComponent.galleries.push(gallery);
        });
    }

    // set selected Gallery
    function setSelectedGallery(galleryComponentHeader, selectedGalleryLink) {
        galleryComponent.selectedGallery = galleryComponent.galleries.findIndex(gallery => gallery.galleryTab === selectedGalleryLink.dataset.tab);
        // remove `selected` class from all Gallery buttons
        Array.from(galleryComponentHeader.querySelectorAll('.selected'), (e) =>
            e.classList.remove('selected')
        );
        selectedGalleryLink.classList.add('selected');
        galleryComponentHeader
            .querySelector(`div.gallery-tab-header-content[data-tab*="${selectedGalleryLink.dataset.tab}"]`)
            .classList.add('selected');
        const galleryContent = galleryComponentHeader.querySelector(`div.gallery-tab-header-content[data-tab*="${selectedGalleryLink.dataset.tab}"]`);
        if (mobileGalleryView()) {
            const gallerySelect = galleryContent.querySelector('.gallery-select');
            gallerySelect.selectedIndex = galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab;
            const gallerySelectComponent = galleryContent.querySelector('.gallery-select-component');
            setActivetMobileGalleryTab(gallerySelectComponent);
        } else {
            const tab = galleryComponentHeader.querySelector(`.tablinks[data-id*="${galleryComponent.galleries[galleryComponent.selectedGallery].tabs[galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab].id}"]`)
            setActiveGalleryTab(tab);
        }
    }

    // set active gallery tab (desktop)
    function setActiveGalleryTab(activeTab) {
        const galleryTabComponent = activeTab.parentElement;

        // get all the tablinks and clear the current active tab
        Array.from(galleryTabComponent.querySelectorAll('.active'), (e) =>
            e.classList.remove('active')
        );
        activeTab.classList.add('active');
        // get the Gallery wrapper
        let galleryWrapper = galleryTabComponent.parentElement.querySelector('.tab-content-wrapper');
        Array.from(galleryWrapper.querySelectorAll('.active'), (e) =>
            e.classList.remove('active')
        );
        let activeTabContent = galleryWrapper.querySelector(`div.tab-item-content[data-id*="${activeTab.dataset.id}"]`);
        activeTabContent.classList.add('active');
        let galleryItems = activeTabContent.querySelectorAll('.gallery-item:not(.lg-initialised)');
        if (galleryItems && galleryItems.length > 0) {
            initializeLightGallery(galleryItems);
        }
        // save the ID of the active tab:
        galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab = galleryComponent.galleries[galleryComponent.selectedGallery].tabs.findIndex(tab => tab.id === activeTab.dataset.id);
    }
    
    function setFirstTabItemsVisible() {
        // get the gallery
        const selectedGalleryContent = document.querySelector(`.gallery-tab-header-content[data-tab*="${galleryComponent.galleries[galleryComponent.selectedGallery].galleryTab}"]`);
        const selectedIndex = galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab;

        // get the select
        const sel = selectedGalleryContent.querySelector('.gallery-select');
        sel.selectedIndex = selectedIndex;

        const selectContentList = selectedGalleryContent.querySelectorAll('.select-content-list .select-content');
        selectContentList[selectedIndex].classList.add('visible');
    }  

    function initializeMobileGallery() {
        // Add count of media items to mobile dropdown - THIS DOES NOT WORK
        if (!galleryComponent.scEditorMode) {
            // counting images for select mobile gallery
            // select all options
            // select all select-content group, and loop through each group
            // find each groups' children count and append to each option by order
            const GAL_SEL = document.querySelector('.gallery-select');
            const options = [...GAL_SEL.querySelectorAll('option')];
            const selectContentGroups = [...GAL_SEL.querySelectorAll('.select-content')];

            // I don't think this ever gets called
            selectContentGroups.forEach((group, idx) => {
                const imgCount = group.querySelectorAll('.gallery-item').length;
                const optionText = options[idx].textContent;
                options[idx].innerHTML = `${optionText} (${imgCount})`;
            });
        }

        //logic for gallery dropdown on mobile view
        const GALLERY_SELECT = document.querySelectorAll('.gallery-select-component');
        if (GALLERY_SELECT) {
            if (document.readyState !== 'complete') {
                window.addEventListener('load', setFirstTabItemsVisible);
            } else {
                setFirstTabItemsVisible();
            }
            GALLERY_SELECT.forEach((galSelComp) => {
                let valueNew = () => {
                    setActivetMobileGalleryTab(galSelComp);
                };

                Array.from(galSelComp.getElementsByClassName('gallery-select'), (select) => 
                    select.addEventListener('change', valueNew, false)
                );
            });
        }

        //init lightbox plugin on items in mobile Gallery
        const MEDIA_CONTENT = document.querySelectorAll('.desktop-hidden .gallery-layout');
        if (MEDIA_CONTENT) {
            // this is only executed on mobile, but initialises all Desktop gallery items
            MEDIA_CONTENT.forEach((media) => {
                const initLightboxEl = media.querySelector('.grid');
                let galleryItems = initLightboxEl.querySelectorAll('.gallery-item');
                if (galleryItems && galleryItems.length > 0) {
                    initializeLightGallery(galleryItems);
                }
            });
        }

        galleryComponent.mobileInitialised = true;

    }

    function setActivetMobileGalleryTab(gallerySelectComponent) {
        const selectContent = gallerySelectComponent.querySelectorAll('.select-content');
        const gallerySelect = gallerySelectComponent.querySelector('.gallery-select');
        selectContent.forEach((content) => {
            content.classList.remove('visible');
        });
        selectContent[gallerySelect.selectedIndex].classList.add('visible');
        galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab = gallerySelect.selectedIndex;
    }

    function addCountToTabLabels() {
        Array.from(document.getElementsByClassName('simple-link'), (btn) => {
            const count = document.querySelectorAll(
                `div.tab-item-content[data-id="${btn.dataset.id}"] .gallery-item`
            ).length;
            btn.appendChild(document.createTextNode(` (${count})`));
        });
    }

    function initializeDesktopGallery() {
        // Create on Load handler to add count to gallery Tab headers
        const SIMPLE_LINK = document.querySelectorAll('.simple-link');
        if (SIMPLE_LINK) {
            if (document.readyState !== 'complete') {
                window.addEventListener('load', addCountToTabLabels);
            } else {
                addCountToTabLabels();
            }
        }

        if (!galleryComponent.scEditorMode) {
            //on page load first btn of gallery content link is active and the content is visible
            const galleryComponentHeader = galleryComponent.component.querySelector('.gallery-header');
            const tab = galleryComponentHeader.querySelector(`.tablinks[data-id*="${galleryComponent.galleries[galleryComponent.selectedGallery].tabs[galleryComponent.galleries[galleryComponent.selectedGallery].selectedTab].id}"]`)
            if (document.readyState !== 'complete') {
                window.addEventListener('load', () => {
                    setActiveGalleryTab(tab);
                });
            } else {
                setActiveGalleryTab(tab);
            }
        }

        let handleClick = (e) => {
            setActiveGalleryTab(e.target);
        };
        // get the gallery tabs
        const tablinks = galleryComponent.component.querySelectorAll('.tablinks');
        Array.from(tablinks, (tablink) =>
        {
            tablink.addEventListener('click', handleClick, false);
        });

        //init lightbox plugin
        const MEDIA_CONTENT = document.querySelectorAll('.mobile-hidden .gallery-layout');
        if (MEDIA_CONTENT) {
            //center gallery link if it's less than 10 elements
            const GALLERY_LINK_WRAPPER = document.querySelectorAll('.gallery-links-wrapper');
            GALLERY_LINK_WRAPPER.forEach((wrapper) => {
                const GALLERY_LINK_WRAPPER_CHILDREN = wrapper.childElementCount;
                if (GALLERY_LINK_WRAPPER_CHILDREN < 10) {
                    wrapper.style.justifyContent = 'center';
                }
            });
        }

        galleryComponent.desktopInitialised = true;
    }

    //initialize lightGallery for each gallery-layout
    function initializeLightGallery(galleryItems) {
        let galleryItemsArray = [];
        galleryItems.forEach((galleryElement) => {
            let imgSrc = galleryElement.dataset.src ? galleryElement.dataset.src : galleryElement.querySelector('img').src;
            let galleryObj = {
                "src": imgSrc,
                "thumb": imgSrc,
                "subHtml": galleryElement.dataset.subHtml ? galleryElement.dataset.subHtml : ""
            };
            if (galleryElement.dataset.iframe) {
                galleryObj = {
                    "src": imgSrc,
                    "thumb": galleryElement.querySelector('img').src ? galleryElement.querySelector('img').src : imgSrc,
                    "subHtml": galleryElement.dataset.subHtml ? galleryElement.dataset.subHtml : "",
                    "iframe": true,
                };
            }
            if (galleryElement.dataset.poster) {
                galleryObj = {
                    "src": imgSrc,
                    "poster": galleryElement.dataset.poster,
                    "subHtml": galleryElement.dataset.subHtml ? galleryElement.dataset.subHtml : "",
                };
            }
            galleryItemsArray.push(galleryObj);
        });
        galleryItems.forEach(galleryItem => {
            if (galleryItem.dataset.iframe) {
                let iframeSelector = '.lg-video iframe.lg-object';
                galleryItem.addEventListener('onAfterOpen', event => {
                    videoUtils.sandboxVideos(iframeSelector);
                });
                galleryItem.addEventListener('onBeforeSlide', event => {
                    videoUtils.sandboxVideos(iframeSelector);
                });
            }
            galleryItem.addEventListener('click', event => {
                const currentItemIndex = galleryItem.dataset.index;
                lightGallery(galleryItem, {
                    dynamic: true,
                    index: parseInt(currentItemIndex),
                    mode: 'lg-slide',
                    zoom: (galleryItem.dataset.iframe ? false : true),
                    fullScreen: (galleryItem.dataset.iframe ? false : true),
                    getCaptionFromTitleOrAlt: true,
                    download: false,
                    share: false,
                    subHtmlSelectorRelative: true,
                    dynamicEl: galleryItemsArray,
                });
            });
    
            galleryItem.classList.add('lg-initialised');
        });
    }
    // mobileGalleryView checks if we are showing the mobile layout using the media query from developments\_gallery.scss
    function mobileGalleryView() {
        let mql = window.matchMedia("(max-width: 1023px)");
        return mql.matches; 
    }
}
